export type IziviaServerEnvironment = 'production' | 'PP' | 'sandbox' | 'QA';

export interface IziviaCustomEnvironment {
    serverKey: string;
    serverUrl: string;
}

export function isCustomEnvironment(environment: IziviaServerEnvironment | IziviaCustomEnvironment): environment is IziviaCustomEnvironment {
    return (environment as IziviaCustomEnvironment).serverKey !== undefined;
}
